import { render } from "./ApprovalsListMessage.vue?vue&type=template&id=5237b274"
import script from "./ApprovalsListMessage.vue?vue&type=script&lang=js"
export * from "./ApprovalsListMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__